import type { AttachedCompanies } from './attachedCompanies.types';

import { getCurrentCompanyId, setCurrentCompanyId } from 'Lib/Utils';
import { ATTACHED_COMPANIES_LOCAL_STORAGE_KEY } from './attachedCompanies.constants';

export const setAttachedCompanies = (attachedCompanies: AttachedCompanies) => {
    localStorage.setItem(ATTACHED_COMPANIES_LOCAL_STORAGE_KEY, JSON.stringify(attachedCompanies));

    // If there is an active company, retrigger side effects of setting the company. This is because some side effects of setting the company depends on the attached companies, so if the attached companies change, we need to retrigger those side effects. // FIXME: Should probably just replace all of these things with react-query custom hooks that depend on the other data.
    const currentCompanyId = getCurrentCompanyId();
    currentCompanyId && setCurrentCompanyId(currentCompanyId);
};
